module.exports = __webpack_public_path__ + "img/instrucoes-como-fazer-selfie.a8351510.png";